<template>
  <!-- The page that is printed. It only exists while the print dialog is open, directly under
       <body>, so print can hide everything else and show just this. The table repeats an empty
       row at the top and bottom of every page: that is the page margin, made without @page
       margins (which would make the browser print its own header and footer in them). -->
  <Teleport to="body">
    <div class="resume-print-root" aria-hidden="true">
      <div class="bg-white text-gray-900" :style="pageStyle">
        <table class="resume-print-table">
          <thead><tr><td :style="{ height: `${padding}px`, padding: 0 }"></td></tr></thead>
          <tbody><tr><td style="padding: 0"><ResumeSheetBody :content="content" :template="template" :picture-url="pictureUrl" /></td></tr></tbody>
          <tfoot><tr><td :style="{ height: `${padding}px`, padding: 0 }"></td></tr></tfoot>
        </table>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import ResumeSheetBody from './ResumeSheetBody.vue'
import { horizontalPaddingOf, paddingOf, sheetBackground, typography } from './resumeLayout.js'

const props = defineProps({
  content: { type: Object, required: true },
  template: { type: String, default: 'modern' },
  pictureUrl: { type: String, default: null },
})

const padding = computed(() => paddingOf(props.content.settings))
const pageStyle = computed(() => ({
  ...typography(props.content.settings),
  width: '210mm',
  padding: `0 ${horizontalPaddingOf(props.template, props.content.settings)}px`,
  boxSizing: 'border-box',
  ...sheetBackground(props.template, props.content.settings),
}))
</script>

<style>
.resume-print-root { display: none; }
.resume-print-table { width: 100%; border-collapse: collapse; }

/* Only while printing from the editor (the class is added for the moment the dialog is open) */
@media print {
  body.resume-printing { background: #fff !important; }
  body.resume-printing > *:not(.resume-print-root) { display: none !important; }
  body.resume-printing .resume-print-root { display: block !important; }
  body.resume-printing .resume-print-root * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  body.resume-printing .resume-print-root .resume-entry { break-inside: avoid; }
  body.resume-printing .resume-print-root .resume-section > h2 { break-after: avoid; }
}
</style>
